// voltage: image set double-filter
// Extends Reformation's image-set system from one option to N options.
// Alt-text format: "Caption #color_red #material_polished-brass" (space-separated tags).
// Slides with one tag behave as before; slides with 2+ tags must match all selections.
(function () {
  function normalizeValue(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function readSelections(variantSelects) {
    var selections = {};
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var fs = fieldsets[i];
      var handle = fs.dataset.handle;
      if (!handle) continue;
      var raw;
      var sel = fs.querySelector('select');
      if (sel) {
        raw = sel.value;
      } else {
        var checked = fs.querySelector('input:checked');
        if (checked) raw = checked.value;
      }
      if (raw != null) selections[handle] = normalizeValue(raw);
    }
    return selections;
  }

  function refine(variantSelects) {
    var slider = variantSelects.productSlider;
    if (!slider) return;
    var selections = readSelections(variantSelects);
    var tagged = slider.querySelectorAll('[data-voltage-tags]');
    for (var i = 0; i < tagged.length; i++) {
      var el = tagged[i];
      var tags = el.dataset.voltageTags.trim().split(/\s+/);
      if (tags.length < 2) continue;
      var allMatch = true;
      for (var j = 0; j < tags.length; j++) {
        var sep = tags[j].indexOf('_');
        if (sep < 0) { allMatch = false; break; }
        var handle = tags[j].slice(0, sep);
        var value = tags[j].slice(sep + 1);
        if (selections[handle] !== value) { allMatch = false; break; }
      }
      el.classList.toggle('is-active', allMatch);
    }
  }

  function patch() {
    if (!window.customElements) return;
    var ctor = customElements.get('variant-selects');
    if (!ctor) return setTimeout(patch, 50);
    var orig = ctor.prototype.setImageSetMedia;
    ctor.prototype.setImageSetMedia = function () {
      var r = orig.apply(this, arguments);
      try { refine(this); } catch (e) { console.error('[voltage] image refine failed', e); }
      return r;
    };
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      try { refine(vs); } catch (e) {}
    });
  }
  patch();
})();

// voltage: sloped ceiling option
// Opt-in checkbox on the PDP adds a linked "Sloped Ceiling" variant (from the
// variant metafield custom.sloped_ceiling_variant) as its own cart line item,
// paired to the main item via a hidden _sloped_link property. The pair is then
// kept in sync: quantity follows the main item, and removing the main item
// removes the add-on. Built entirely on Reformation's documented cart events.
(function () {
  var reconcileGuard = false;

  function addUrl() { return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add'; }
  function changeUrl() { return (window.theme && theme.routes && theme.routes.cart_change_url) || '/cart/change'; }

  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) throw new Error(url + ' responded ' + r.status);
      return r.json();
    });
  }

  function refreshCartUI() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // Add-on item add — fires after the main product is added (cart:item-added)
  function addSloped(slopedVariantId, quantity, linkId) {
    return postJSON(addUrl(), {
      items: [{
        id: slopedVariantId,
        quantity: quantity,
        properties: { _sloped_link: linkId, _sloped_role: 'addon' }
      }]
    });
  }

  // Whole-cart reconcile — self-healing: runs after every line-item change
  function reconcile(cart) {
    if (!cart || !cart.items) return;
    var groups = {};
    cart.items.forEach(function (item) {
      var props = item.properties || {};
      var link = props._sloped_link;
      if (!link) return;
      groups[link] = groups[link] || { parent: null, addon: null };
      if (props._sloped_role === 'addon') groups[link].addon = item;
      else groups[link].parent = item;
    });
    var changes = [];
    Object.keys(groups).forEach(function (link) {
      var g = groups[link];
      if (g.addon && !g.parent) {
        changes.push({ id: g.addon.key, quantity: 0 });           // parent gone -> drop add-on
      } else if (g.addon && g.parent && g.addon.quantity !== g.parent.quantity) {
        changes.push({ id: g.addon.key, quantity: g.parent.quantity }); // sync qty to parent
      }
    });
    if (!changes.length) return;
    reconcileGuard = true;
    var chain = Promise.resolve();
    changes.forEach(function (c) {
      chain = chain.then(function () { return postJSON(changeUrl(), { id: c.id, quantity: c.quantity }); });
    });
    chain.then(function () { reconcileGuard = false; refreshCartUI(); })
         .catch(function (e) { reconcileGuard = false; console.error('[voltage] sloped reconcile failed', e); });
  }

  function init() {
    var root = document.querySelector('[data-voltage-sloped]');
    var map = {};
    if (root) {
      var mapEl = root.querySelector('[data-voltage-sloped-map]');
      try { map = JSON.parse(mapEl.textContent); } catch (e) { console.error('[voltage] sloped map parse failed', e); }
    }

    // PDP checkbox wiring (only when the snippet rendered on this page)
    if (root) {
      var checkbox = root.querySelector('.voltage-sloped__checkbox');
      var priceEl = root.querySelector('.voltage-sloped__price');
      var propVisible = root.querySelector('[data-voltage-sloped-prop-visible]');
      var propLink = root.querySelector('[data-voltage-sloped-prop-link]');
      var currentVariantId = String(root.dataset.currentVariant);

      var syncProps = function () {
        var on = !root.hidden && checkbox.checked;
        if (on && !propLink.value) {
          propLink.value = 'sloped-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8);
        }
        propVisible.disabled = !on;
        propLink.disabled = !on;
      };

      var refreshUI = function () {
        var entry = map[currentVariantId];
        if (entry && entry.available) {
          root.hidden = false;
          priceEl.textContent = entry.priceFormatted ? ' (+' + entry.priceFormatted + ')' : '';
        } else {
          root.hidden = true;
          checkbox.checked = false;
        }
        syncProps();
      };

      checkbox.addEventListener('change', syncProps);
      // NOTE: the theme's `product:variant-change` event carries a STALE variant —
      // renderVariantInfo() resolves the new variant async, after the event fires.
      // updateVariantInput() sets the form's input[name="id"] to the resolved id
      // and fires a bubbling 'change' on it once the fetch completes — use that.
      var form = root.closest('form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      if (idInput) {
        idInput.addEventListener('change', function () {
          if (idInput.value) {
            currentVariantId = String(idInput.value);
            refreshUI();
          }
        });
      }
      refreshUI();
    }

    // Add-on trigger — keyed off the hidden _sloped_link property on the added item,
    // so it only fires for a main product added with the box checked.
    document.addEventListener('cart:item-added', function (evt) {
      var added = evt.detail && evt.detail.product;
      var props = added && added.properties;
      var linkId = props && props._sloped_link;
      if (!linkId) return;
      var addedVariantId = String(added.id || added.variant_id);
      var entry = map[addedVariantId];
      if (!entry) return;
      addSloped(entry.id, added.quantity || 1, linkId)
        .then(function () { refreshCartUI(); })
        .catch(function (e) { console.error('[voltage] sloped add failed', e); });
      if (root) {
        var cb = root.querySelector('.voltage-sloped__checkbox');
        var link = root.querySelector('[data-voltage-sloped-prop-link]');
        cb.checked = false;
        link.value = '';
        link.disabled = true;
        root.querySelector('[data-voltage-sloped-prop-visible]').disabled = true;
      }
    });

    // Cart sync — reconcile pairs after every line-item change
    document.addEventListener('line-item:change:end', function (evt) {
      if (reconcileGuard) return;
      reconcile(evt.detail && evt.detail.cart);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// voltage: auto-select first available dropdown option when current becomes unavailable
// Pairs with the CSS rule that hides [data-available="false"] options. Without this,
// a customer whose previously-selected option becomes invalid after changing another
// option would see Add-to-Cart go "Unavailable" with a hidden-but-selected option
// stuck in the dropdown. This jumps them to the first valid option instead, so the
// PDP always shows a buyable combination.
//
// Hook: MutationObserver on [data-available] inside variant-selects. Vendor syncs
// these attributes inside renderVariantInfo's .then() callback BEFORE the no-variant
// early-return — so this fires in the critical case where the new combo is invalid
// (e.g. 30" chandelier + 20" drop), which is precisely when input[name="id"] change
// does NOT fire because updateVariantInput() never runs. Scoped to dropdowns.
(function () {
  var reconcileGuard = false;

  function reconcileDropdowns() {
    if (reconcileGuard) return;
    var dispatchTarget = null;
    document.querySelectorAll('variant-selects .product-form__input--dropdown select').forEach(function (sel) {
      var curOpt = sel.options[sel.selectedIndex];
      if (!curOpt || curOpt.dataset.available !== 'false') return;
      var firstAvail = Array.from(sel.options).find(function (o) { return o.dataset.available !== 'false'; });
      if (!firstAvail || firstAvail === curOpt) return;
      sel.value = firstAvail.value;
      if (!dispatchTarget) dispatchTarget = sel;
    });
    if (dispatchTarget) {
      reconcileGuard = true;
      // One bubbling change is enough — vendor's onVariantChange re-reads all option values.
      dispatchTarget.dispatchEvent(new Event('change', { bubbles: true }));
      setTimeout(function () { reconcileGuard = false; }, 800);
    }
  }

  function initAutoSelect() {
    // Initial pass — covers the rare case where default selections are invalid.
    reconcileDropdowns();
    // Observe data-available changes on every variant-selects. Vendor's sync happens
    // inside the variant fetch .then() callback regardless of whether the resulting
    // variant resolves, so this fires both for valid AND invalid-combo transitions.
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      new MutationObserver(function (mutations) {
        var relevant = mutations.some(function (m) { return m.attributeName === 'data-available'; });
        if (relevant) reconcileDropdowns();
      }).observe(vs, {
        attributes: true,
        attributeFilter: ['data-available'],
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoSelect);
  } else {
    initAutoSelect();
  }
})();
